import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// Service worker DEVRE DISI — web sadece admin/upload araci, offline gerekmiyor.
// register() cache sorunlarina yol aciyordu (kullanici eski surumu goruyordu).
// unregister() zaten kayitli SW'leri de temizler → herkes her zaman guncel surumu gorur.
serviceWorkerRegistration.unregister();
